import React from 'react';
import Button from '../components/Button';
import { useRedirect } from '../hooks/useRedirect';
import pathnames from '../routes/index.route';
import allset from '../assets/icons/allset.png';
import logo from '../assets/images/logo.png';
import previewApp from '../assets/images/ourapp.png';

const AllSet = () => {
  const navigate = useRedirect();
  return (
    <section className="lg:flex">
      <div className="bg-[#6833ff] background w-full h-[450px] sm:h-[550px] lg:h-screen overflow-hidden relative hidden lg:block">
        <div className="container mx-auto px-4 lg:px-10 mt-8 text-white">
          <div className='flex-col items-center justify-between'>
            <div>
              <img src={logo} alt="logo" className="w-[100px] sm:w-[200px]" />
              <h1 className="text-2xl lg:text-6xl font-medium text-center lg:text-start leading-tight mt-10 lg:w-[600px]">
                Make your content
                translation cheaper
                and much easier
              </h1>
              <p className="text-xs md:text-xl lg:text-xl mt-4 text-center lg:text-start">Save over 90% of the workload stress of social <br /> media accounts management efforts. </p>
            </div>
            <img className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[400px] sm:w-[550px] lg:w-[650px] md:mx-auto" src={previewApp} alt="previewApp" />
          </div>
        </div>
      </div>
      <div className="bg-[#F2F0FA] w-full h-screen relative">
        <div className="container mx-auto h-full">
          <div className="flex items-center justify-center w-full h-full">
            <div className="w-[85%] sm:w-[358px] mt-8 text-center">
              <img src={allset} alt="allset" className="w-[80px] h-[70px] inline-block" />
              <h1 className="text-2xl text-[#0F0C18] font-medium mt-4">All set!</h1>
              <p className="text-sm font-medium text-[#9392A2] mt-5 mb-28">You are ready to use <br />
                Dubmate!</p>
              <Button onClick={() => navigate(pathnames.home)} label="Start using the Dubmate" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllSet;